// @flow weak
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { ActivityIndicator } from 'trpc-react-native-ui';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import LineRow from '../../components/lines/LineRow';
import { FullButton } from '../../components/common';
import I18n from '../../lib/i18n';
import config from '../../config';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import type { Subscription } from 'digicel-kaizen-library';

class LineSelector extends Component<Props> {
  render() {
    return (
      <KeyboardAwareScrollView
        contentContainerStyle={styles.container}
        keyboardShouldPersistTaps="always"
        enableOnAndroid="true">
        {this.props.isFetching ? (
          <ActivityIndicator />
        ) : (
          this.props.subscriptions.map(subscription => {
            const selected = this.props.selectedSubscription && this.props.selectedSubscription.ouid === subscription.ouid;
            return <LineRow key={subscription.ouid} subscription={subscription} selected={selected} />;
          })
        )}
        {config.canAddLines && !this.props.isEditing && (
          <View style={styles.buttonContainer}>
            <FullButton
              onPress={this.props.goToSignUp}
              text={I18n.t('LineSelector.addLine')}
              isLoading={this.props.isInitializingSignUp}
            />
          </View>
        )}
      </KeyboardAwareScrollView>
    );
  }
}

type Props = {
  goToSignUp: Function,
  isEditing: boolean,
  isFailure: boolean,
  isFetching: boolean,
  isInitializingSignUp: boolean,
  navigation: NavigationScreenProp<NavigationRoute>,
  selectedSubscription: Subscription,
  subscriptions: Subscription[],
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  buttonContainer: {
    marginVertical: 20,
    marginHorizontal: 15,
  },
});

export default LineSelector;
